import React from "react";
import { useTranslation } from "react-i18next";
import { useBrandingContext } from "context/BrandingContext";
import { UserBlock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import StatusPage from "components/common/StatusPage";

const Inactive: React.FC = () => {
  const { t } = useTranslation();
  const { platform } = useBrandingContext();
  const supportEmail = platform?.email || "support@outpave.com";

  return (
    <StatusPage
      title={t("Your company is deactivated")}
      message={t(
        "If this is an error, please contact your account representative or Outpave support",
      )}
      icon={UserBlock01Icon}
      // Reloading changes nothing here; a person is the only way out, so the
      // action is the message rather than a second copy of the address.
      action={{
        label: t("Contact support"),
        href: `mailto:${supportEmail}`,
      }}
    />
  );
};

export default Inactive;
